/**
 * Shared skip-approval modal: Begründung textarea + optional preset radios (same UX as external capex skip).
 */

var SKIP_APPROVAL_DIALOG_FONT_FAMILY =
  "'Fustat', 'IBM Plex Sans', 'Arial', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Fira Sans', 'Oxygen', 'Segoe UI', 'Roboto', 'Ubuntu', 'Cantarell', 'Droid Sans', sans-serif"

var MIN_SKIP_REASON_LENGTH = 5

function luxApprovalKebabRow(el) {
  if (!el || !el.closest) return null
  return el.closest('.approval-card-row')
}

function closeAllLuxApprovalKebabDropdowns() {
  document.querySelectorAll('.lux-approval-kebab-dropdown').forEach(function (d) {
    d.style.display = 'none'
  })
  document.querySelectorAll('.lux-approval-kebab > button').forEach(function (b) {
    if (b.innerHTML === '⋮') b.style.opacity = '0.6'
  })
  document.querySelectorAll('.approval-card-row').forEach(function (row) {
    row.style.zIndex = ''
  })
}

function setLuxApprovalKebabRowElevated(row, elevated) {
  if (!row) return
  row.style.zIndex = elevated ? '50' : ''
}

function createLuxApprovalKebabMenu(items) {
  var container = document.createElement('div')
  container.className = 'lux-approval-kebab'
  container.style.cssText = 'position:relative;display:none;flex-shrink:0;'

  var menuButton = document.createElement('button')
  menuButton.type = 'button'
  menuButton.innerHTML = '⋮'
  menuButton.title = 'Aktionen'
  menuButton.style.zIndex = '1'
  menuButton.setAttribute('aria-label', 'Aktionen')
  menuButton.style.cssText =
    'background:none;border:none;cursor:pointer;font-size:18px;padding:4px 8px;' +
    'opacity:0.6;line-height:1;font-weight:bold;color:#1a1a1a;'

  var dropdown = document.createElement('div')
  dropdown.className = 'lux-approval-kebab-dropdown'
  dropdown.style.cssText =
    'display:none;position:absolute;top:100%;right:0;background:#fff;border:1px solid #eee;' +
    'border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,0.15);z-index:1000;min-width:160px;overflow:hidden;'

  var itemEls = {}
  items.forEach(function (item) {
    var opt = document.createElement('button')
    opt.type = 'button'
    opt.textContent = item.label
    opt.style.cssText =
      'display:block;width:100%;padding:10px 16px;border:none;background:none;' +
      'cursor:pointer;text-align:left;font-size:14px;color:#333;'
    opt.addEventListener('mouseover', function () {
      opt.style.backgroundColor = '#f5f5f5'
    })
    opt.addEventListener('mouseout', function () {
      opt.style.backgroundColor = 'transparent'
    })
    opt.addEventListener('click', function (e) {
      e.stopPropagation()
      if (opt.disabled || opt.getAttribute('aria-disabled') === 'true') return
      closeAllLuxApprovalKebabDropdowns()
      item.onClick()
    })
    dropdown.appendChild(opt)
    itemEls[item.id] = opt
  })

  menuButton.addEventListener('click', function (e) {
    e.stopPropagation()
    var isVisible = dropdown.style.display === 'block'
    var row = luxApprovalKebabRow(container)
    closeAllLuxApprovalKebabDropdowns()
    if (!isVisible) {
      dropdown.style.display = 'block'
      menuButton.style.opacity = '1'
      setLuxApprovalKebabRowElevated(row, true)
    }
  })

  document.addEventListener('click', function (e) {
    if (!container.contains(e.target)) {
      if (dropdown.style.display === 'block') {
        closeAllLuxApprovalKebabDropdowns()
      }
    }
  })

  container.appendChild(menuButton)
  container.appendChild(dropdown)

  return {
    container: container,
    setItemVisible: function (id, visible) {
      if (itemEls[id]) itemEls[id].style.display = visible ? 'block' : 'none'
    },
    setItemDisabled: function (id, disabled) {
      var el = itemEls[id]
      if (!el) return
      el.disabled = !!disabled
      el.setAttribute('aria-disabled', disabled ? 'true' : 'false')
      el.style.cursor = disabled ? 'not-allowed' : 'pointer'
      el.style.color = disabled ? '#bbb' : '#333'
      el.style.opacity = disabled ? '0.65' : '1'
    },
    refreshMenuVisible: function () {
      var anyVisible = items.some(function (it) {
        var el = itemEls[it.id]
        return el && el.style.display !== 'none'
      })
      container.style.display = anyVisible ? 'block' : 'none'
    },
    hide: function () {
      container.style.display = 'none'
      dropdown.style.display = 'none'
      menuButton.style.opacity = '0.6'
      setLuxApprovalKebabRowElevated(luxApprovalKebabRow(container), false)
    },
  }
}

/**
 * @param {object} options
 * @param {string} options.overlayId
 * @param {string} options.title
 * @param {number} [options.zIndex=10000]
 * @param {string} options.radioGroupName
 * @param {Array<{ value: string, label: string }>} options.presets
 * @param {function(object): Promise<{ ok: boolean, j: object }>} options.submitRequest - receives JSON body
 * @param {function(object): void} [options.onSuccess]
 * @param {function(string, string|null): object} [options.buildRequestBody] - (reasoning, presetValue) -> body; default { reasoning }
 */
function buildSkipApprovalReasonDialog(options) {
  var overlay = document.createElement('div')
  overlay.id = options.overlayId
  overlay.style.cssText =
    'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:' +
    (options.zIndex != null ? options.zIndex : 10000) +
    ';font-family:' +
    SKIP_APPROVAL_DIALOG_FONT_FAMILY +
    ';'

  var dialog = document.createElement('div')
  dialog.style.cssText =
    'background:#fff;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,0.12);width:90%;max-width:440px;font-family:' +
    SKIP_APPROVAL_DIALOG_FONT_FAMILY +
    ';'

  var header = document.createElement('div')
  header.style.cssText =
    'padding:16px 20px;border-bottom:1px solid #e5e5e5;font-size:18px;font-weight:600;'
  header.textContent = options.title

  var body = document.createElement('div')
  body.style.cssText = 'padding:20px;display:flex;flex-direction:column;gap:14px;'

  var reasonLabel = document.createElement('div')
  reasonLabel.textContent = 'Begründung'
  reasonLabel.style.cssText = 'font-size:14px;font-weight:500;'

  var reasonInput = document.createElement('textarea')
  reasonInput.rows = 3
  reasonInput.className = 'ant-input'
  reasonInput.style.cssText =
    'width:100%;box-sizing:border-box;resize:vertical;font-family:inherit;'
  reasonInput.placeholder = 'Bitte Begründung eingeben…'

  var presetByValue = {}
  ;(options.presets || []).forEach(function (p) {
    presetByValue[p.value] = p.label
  })

  var selectedPreset = null
  var confirmBtn = null
  var presetRadioInputs = []

  function isSkipConfirmEnabled() {
    if (selectedPreset) return true
    var text = (reasonInput.value || '').trim()
    return text.length >= MIN_SKIP_REASON_LENGTH
  }

  function updateConfirmButtonState() {
    if (!confirmBtn || confirmBtn.textContent === 'Speichern…') return
    confirmBtn.disabled = !isSkipConfirmEnabled()
    confirmBtn.style.opacity = confirmBtn.disabled ? '0.55' : '1'
    confirmBtn.style.cursor = confirmBtn.disabled ? 'not-allowed' : 'pointer'
  }

  function syncReasonInputState() {
    var presetActive = !!selectedPreset
    reasonInput.readOnly = presetActive
    reasonInput.disabled = false
    reasonInput.style.opacity = presetActive ? '0.55' : '1'
    reasonInput.style.backgroundColor = presetActive ? '#f5f5f5' : '#fff'
    reasonInput.style.borderColor = ''
    reasonInput.style.cursor = presetActive ? 'pointer' : 'text'
    reasonInput.title = presetActive ? 'Klicken, um eine eigene Begründung einzugeben' : ''
    if (presetActive) reasonInput.value = ''
    updateConfirmButtonState()
  }

  function clearPresetRadioVisual(input) {
    input.checked = false
    input.removeAttribute('checked')
    input.defaultChecked = false
  }

  function switchToFreeTextReasoning() {
    if (!selectedPreset) return
    selectedPreset = null
    presetRadioInputs.forEach(clearPresetRadioVisual)
    syncReasonInputState()
    reasonInput.focus()
    updateConfirmButtonState()
  }

  function makePresetRadio(value, labelText) {
    var wrap = document.createElement('label')
    wrap.style.cssText =
      'display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;'
    var input = document.createElement('input')
    input.type = 'radio'
    input.name = options.radioGroupName
    input.value = value
    presetRadioInputs.push(input)
    input.addEventListener('change', function () {
      if (!input.checked) return
      selectedPreset = value
      syncReasonInputState()
      updateConfirmButtonState()
    })
    wrap.appendChild(input)
    wrap.appendChild(document.createTextNode(labelText))
    return wrap
  }

  body.appendChild(reasonLabel)
  body.appendChild(reasonInput)
  ;(options.presets || []).forEach(function (p) {
    body.appendChild(makePresetRadio(p.value, p.label))
  })

  var footer = document.createElement('div')
  footer.style.cssText =
    'padding:12px 20px 16px;display:flex;justify-content:flex-end;gap:8px;border-top:1px solid #e5e5e5;'

  var cancelBtn = document.createElement('button')
  cancelBtn.type = 'button'
  cancelBtn.className = 'ant-btn'
  cancelBtn.textContent = 'Abbrechen'

  confirmBtn = document.createElement('button')
  confirmBtn.type = 'button'
  confirmBtn.className = 'ant-btn ant-btn-primary'
  confirmBtn.textContent = 'Überspringen'
  confirmBtn.disabled = true
  confirmBtn.style.opacity = '0.55'
  confirmBtn.style.cursor = 'not-allowed'

  reasonInput.addEventListener('mousedown', function () {
    if (selectedPreset) switchToFreeTextReasoning()
  })
  reasonInput.addEventListener('input', function () {
    if (selectedPreset) return
    if ((reasonInput.value || '').trim().length >= MIN_SKIP_REASON_LENGTH) {
      reasonInput.style.borderColor = ''
    }
    updateConfirmButtonState()
  })

  footer.appendChild(cancelBtn)
  footer.appendChild(confirmBtn)
  dialog.appendChild(header)
  dialog.appendChild(body)
  dialog.appendChild(footer)
  overlay.appendChild(dialog)

  function close() {
    overlay.remove()
    document.body.style.overflow = ''
  }

  cancelBtn.onclick = close
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close()
  })

  var buildBody =
    options.buildRequestBody ||
    function (reasoning) {
      return { reasoning: reasoning }
    }

  confirmBtn.onclick = function () {
    if (!isSkipConfirmEnabled()) return
    var reasoning = (reasonInput.value || '').trim()
    if (selectedPreset && presetByValue[selectedPreset]) {
      reasoning = presetByValue[selectedPreset]
    }
    if (!reasoning) {
      reasonInput.style.borderColor = '#ff4d4f'
      return
    }
    if (!selectedPreset && reasoning.length < MIN_SKIP_REASON_LENGTH) {
      reasonInput.style.borderColor = '#ff4d4f'
      return
    }
    confirmBtn.disabled = true
    confirmBtn.textContent = 'Speichern…'
    var bodyPayload = buildBody(reasoning, selectedPreset)
    Promise.resolve(options.submitRequest(bodyPayload))
      .then(function (res) {
        if (!res.ok) {
          alert(res.j && res.j.error ? res.j.error : 'Freigabe konnte nicht übersprungen werden.')
          confirmBtn.textContent = 'Überspringen'
          updateConfirmButtonState()
          return
        }
        close()
        if (options.onSuccess) options.onSuccess(res.j)
      })
      .catch(function () {
        alert('Freigabe konnte nicht übersprungen werden.')
        confirmBtn.textContent = 'Überspringen'
        updateConfirmButtonState()
      })
  }

  document.body.style.overflow = 'hidden'
  document.body.appendChild(overlay)
  reasonInput.focus()
}
